import { memo } from "react"
import { IconProps } from "./interfaces/IconProps.interface"

const MessageCircle = memo((props: IconProps) => {
    const { color = "#000", ...rest } = props
    return (
        <svg width="1em" height="1em" viewBox="0 0 14 14" fill="none" {...rest}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.33614 1.66732C4.5765 1.66732 2.33937 3.90445 2.33937 6.66409C2.33937 7.46283 2.5263 8.21601 2.85818 8.88402C2.93659 9.04184 2.94932 9.22429 2.89359 9.39147L2.04769 11.9291L4.61095 11.1026C4.77669 11.0491 4.95676 11.0627 5.11265 11.1403C5.78154 11.4733 6.53598 11.6609 7.33614 11.6609C10.0958 11.6609 12.3329 9.42373 12.3329 6.66409C12.3329 3.90445 10.0958 1.66732 7.33614 1.66732ZM1.00604 6.66409C1.00604 3.16807 3.84012 0.333984 7.33614 0.333984C10.8322 0.333984 13.6662 3.16807 13.6662 6.66409C13.6662 10.1601 10.8322 12.9942 7.33614 12.9942C6.42378 12.9942 5.55503 12.8008 4.76996 12.4522L1.20331 13.6023C0.964101 13.6794 0.701844 13.6155 0.524998 13.4369C0.348153 13.2583 0.28678 12.9954 0.366262 12.757L1.54449 9.2224C1.19817 8.43939 1.00604 7.5734 1.00604 6.66409Z"
                fill={color}
            />
        </svg>
    )
})

export default MessageCircle
